import { OAuthToRequestPayload } from '../OAuthMapping';
export const getOAuthRequestPayload = (token, provider) => {
  // Post ACQ131: remove ! from below
  return OAuthToRequestPayload[provider](token);
};